import { Select as BaseSelect, type SelectProps, Spinner } from "@heroui/react";

import { useFieldContext, useLanguage } from "@onesolution/hooks";

import Chip from "../Chip";
import { OpenMode } from "../FormDrawer/FormDrawer";
import { defaultSelectItemsRender, shouldDisplayItemPicker } from "./tools";

export function SelectMultiple(
	props: Omit<SelectProps, "children"> & {
		children?: SelectProps["children"];
	},
) {
	const field = useFieldContext<Array<string>>();
	const { t } = useLanguage();

	if (!shouldDisplayItemPicker(props.isLoading, props.items)) return null;

	const mode = field.form.state.values.formOpenMode as OpenMode;

	if (mode === OpenMode.details)
		return (
			<div className="flex gap-2">
				{props.label ? (
					<h6 className="w-max text-foreground-500">{props.label} :</h6>
				) : null}
				{props.isLoading ? (
					<Spinner size="sm" />
				) : (
					field.state.value.map((value) => (
						<Chip key={value}>
							{
								(props.items as Array<{ id: string; name: string }>)?.find(
									(item) => item.id === value,
								)?.name
							}
						</Chip>
					))
				)}
			</div>
		);

	return (
		<BaseSelect
			isClearable
			isMultiline
			placeholder={t("basic.none")}
			labelPlacement="outside"
			selectionMode="multiple"
			selectedKeys={field.state.value}
			onBlur={field.handleBlur}
			aria-label="select"
			onChange={(e) => {
				const newValue = e.target.value?.split(",").filter((i) => i);
				field.handleChange(newValue);
			}}
			errorMessage={t("message.required")}
			{...props}
			items={props.items || []}
		>
			{props.children || defaultSelectItemsRender}
		</BaseSelect>
	);
}
